import {
  Box,
  Button,
  Pagination,
  PaginationItem,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  PrimaryTypography,
  SecondaryTypography,
  StyledOutlinedInput,
  StyledSecondaryTypography,
  StyledTableCell,
  StyledTableRow,
} from "../../Theme";
import { ReactComponent as SearchIcon } from "../../Icons/Search.svg";
import { ReactComponent as SortIcon } from "../../Icons/Sort.svg";
import { ReactComponent as NumberInputIcon } from "../../Icons/NumberInputIcon.svg";
import { ReactComponent as PreviousIcon } from "../../Icons/Previous.svg";
import { ReactComponent as NextIcon } from "../../Icons/Next.svg";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/Exclamatory.svg";
import axiosInstance from "../../Redux/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { ReactComponent as MoreIcon } from "../../Icons/ThreeDot.svg";
import dayjs from "dayjs";
import AlertModal from "../../CommonComponents/modal";
import { PostLoaderModal } from "../../CommonComponents/modal";

const ServiceTable = () => {
  const { LanguageData } = useSelector((state) => state.Language);
  const navigate = useNavigate();
  const [initialRender, setInitialRender] = useState(true);
  const { propertyId } = useSelector((state) => state.PropertyDetails);
  const [rowsPerPage, setRowsPerPage] = useState("20");
  const [paginationData, setPaginationData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [faultList, setFaultList] = useState([]);
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const sortOpen = Boolean(sortAnchorEl);
  const [SelectedsortData, setSelectedsortData] = useState("new");
  const [searchData, setSearchData] = useState("");
  const [showAnchorEl, setshowAnchorEl] = useState(null);
  const showOpen = Boolean(showAnchorEl);
  const [Tableloading, setTableloading] = useState(true);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const MoreOpen = Boolean(moreAnchorEl);
  const [item, setItem] = useState({});
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [postLoader, SetPostLoader] = useState(false);

  let deleteModalDatas = {
    label:
      LanguageData?.Announcement_Single_DeleteHeader1 || "Confirm to delete",
    descriptionOne:
      LanguageData?.Announcement_Single_DeleteSubHeader1 ||
      "Please confirm that you wish to delete the selected service.",

    buttonOne: {
      variant: "outlined",
      color: "#0E5E84",
      backgroundColor: "#FFFFFF",
      text: LanguageData?.Announcement_Cancel || "Cancel",
    },
    buttonTwo: {
      variant: "contained",
      color: "#FFFFFF",
      backgroundColor: "#B42318",
      text: LanguageData?.Common_Confirm || "Confirm",
    },
  };

  const getAllFaultReport = async () => {
    setTableloading(true);
    setMoreAnchorEl(null);
    setFaultList([]);

    await axiosInstance
      .get(
        // `${process.env.REACT_APP_API_URL}fault_report/property/${propertyId}?page=${currentPage}&record_count=${rowsPerPage}&status_id=${data}&sort=${SelectedsortData}&search=${searchData}`
        `${process.env.REACT_APP_API_URL}item-master/${propertyId}?page=${currentPage}&record_count=${rowsPerPage}&sort=${SelectedsortData}&search=${searchData}`
      )
      .then((data) => {
        console.log(data);
        setFaultList(data?.data?.data?.invoices || []);
        setPaginationData(data?.data?.data?.pagination_details);
        setTableloading(false);
      })
      .catch((err) => {
        console.log(err);
        console.log(err?.response?.data?.error);
        if (err?.response?.data?.error == "No data found") {
          setFaultList([]);
        }
        setTableloading(false);
      });
  };

  useEffect(() => {
    getAllFaultReport();
  }, [currentPage]);

  useEffect(() => {
    if (!initialRender) {
      if (currentPage != 1) {
        setCurrentPage(1);
      } else {
        getAllFaultReport();
      }
    } else {
      setInitialRender(false);
    }
  }, [rowsPerPage, SelectedsortData, searchData]);

  const handleDelete = async () => {
    try {
      SetPostLoader(true);
      const response = await axiosInstance.delete(
        `${process.env.REACT_APP_API_URL}item-master/${item.id}/property/${propertyId}`
      );
      if (response?.data?.success) {
        console.log(response);
        closemodal();
        getAllFaultReport();
      }
    } catch (error) {
      console.log(error);
    } finally {
      SetPostLoader(false);
    }
  };

  const closemodal = () => {
    setshowDeleteModal(false);
  };

  return (
    <>
      {postLoader && <PostLoaderModal />}

      {showDeleteModal && (
        <AlertModal
          modalDatas={deleteModalDatas}
          confirmFunction={handleDelete}
          closeFunction={closemodal}
        />
      )}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box>
          <PrimaryTypography>Service and Product Items</PrimaryTypography>
          <StyledSecondaryTypography>
            A table containing all invoice items submitted in the LOBY system.
          </StyledSecondaryTypography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <Button
            sx={{
              height: "40px",
              padding: "10px 16px",
              borderRadius: "8px",
              backgroundColor: "#0E5E84",
              color: "#FFF",
              fontSize: "14px",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#0E4965",
              },
            }}
            onClick={() => navigate("add-item")}
          >
            Create Service
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          p: 3,
          mt: 4,
          borderRadius: "8px 8px 0px 0px",
          overflowX: "scroll",
          "::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between", // ✅ space between search & sort
            alignItems: "center",
            height: "40px",
            minWidth: "580px",
          }}
        >
          {/* Search */}
          <StyledOutlinedInput
            sx={{ width: "400px" }} // ✅ smaller width instead of flexGrow
            placeholder="Search"
            onChange={(e) => {
              setSearchData(e.target.value);
            }}
            startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
          />

          {/* Sort */}
          <Box
            onClick={(e) => {
              setSortAnchorEl(e.currentTarget);
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #D2D6DB",
              borderRadius: "6px",
              padding: "10px 16px",
              "&:hover": { cursor: "pointer", backgroundColor: "#F9FAFB" },
            }}
          >
            <SortIcon style={{ marginRight: "10px" }} />
            <SecondaryTypography>
              {LanguageData?.sort_filter || "Sort"}
            </SecondaryTypography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{ border: "1px solid #E5E7EB", borderRadius: "0px 0px 8px 8px" }}
      >
        {faultList?.length > 0 ? (
          <>
            <TableContainer>
              <Table>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>S.No</StyledTableCell>
                    <StyledTableCell>Item Name</StyledTableCell>
                    <StyledTableCell>Unit</StyledTableCell>
                    <StyledTableCell>Qty</StyledTableCell>
                    <StyledTableCell>Price</StyledTableCell>
                    <StyledTableCell>Last Edited</StyledTableCell>
                    <StyledTableCell>Actions</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {faultList?.map((value, index) => {
                    return (
                      <StyledTableRow sx={{ height: "70px" }} key={index}>
                        <StyledTableCell>{index + 1}</StyledTableCell>
                        <StyledTableCell>{value?.item_name}</StyledTableCell>
                        <StyledTableCell>{value?.unit_name}</StyledTableCell>
                        <StyledTableCell>{value?.quantity}</StyledTableCell>
                        <StyledTableCell>S${value?.price}</StyledTableCell>
                        <StyledTableCell>
                          {dayjs(value?.updated_at).format("DD MMM YYYY")}
                        </StyledTableCell>
                        <StyledTableCell onClick={() => setItem(value)}>
                          <MoreIcon
                            onClick={(e) => setMoreAnchorEl(e.currentTarget)}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                borderTopStyle: "none !important",
                // border: "1px solid #E5E7EB",
                borderRadius: "0px 0px 8px 8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 2.5,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{ color: "#4D5761", fontSize: "14px", fontWeight: 500 }}
                >
                  {LanguageData?.Common_Show || "Show :"}
                </Typography>
                {/* <OutlinedInput inputProps={{ min: 5, max: 30, step: 5 }} value={rowsPerPage} onChange={(e) => { setRowsPerPage(e.target.value); setCurrentPage('1') }} type='number' sx={{ height: '40px', width: '100px', ml: 2, borderRadius: '8px' }} /> */}
                <Box
                  onClick={(e) => setshowAnchorEl(e.currentTarget)}
                  sx={{
                    width: "95px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px",
                    ml: 2,
                    "&:hover": { cursor: "pointer" },
                  }}
                >
                  <Typography
                    sx={{ fontSize: "15px" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {rowsPerPage} rows{" "}
                    <NumberInputIcon style={{ paddingLeft: "5px" }} />
                  </Typography>
                </Box>
              </Box>
              <Pagination
                size="medium"
                page={currentPage}
                count={paginationData?.last_page}
                onChange={(e, value) => setCurrentPage(value)}
                shape="rounded"
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: PreviousIcon, next: NextIcon }}
                    {...item}
                  />
                )}
              />
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "50vh",
              justifyContent: "center",
            }}
          >
            {Tableloading ? (
              <CircularProgress />
            ) : (
              <>
                <ExclamatoryIcon />
                <Typography
                  sx={{
                    color: "#9DA4AE",
                    fontSize: "16px",
                    fontWeight: 600,
                    my: 2,
                  }}
                >
                  No Services Found
                </Typography>
                <StyledSecondaryTypography>
                  There are no services in the table right now.
                </StyledSecondaryTypography>
                <StyledSecondaryTypography>
                  You can add a new service using the "Create Service" option
                  above.
                </StyledSecondaryTypography>
              </>
            )}
          </Box>
        )}
      </Box>

      <Menu
        sx={{ m: 0.5 }}
        open={sortOpen}
        anchorEl={sortAnchorEl}
        onClose={() => setSortAnchorEl(null)}
      >
        <MenuItem
          sx={{ backgroundColor: SelectedsortData === "new" ? "#eff3f5" : "" }}
          onClick={() => {
            setSelectedsortData("new");
            setSortAnchorEl(null);
          }}
        >
          <Typography>Newest</Typography>
        </MenuItem>
        <MenuItem
          sx={{ backgroundColor: SelectedsortData === "old" ? "#eff3f5" : "" }}
          onClick={() => {
            setSelectedsortData("old");
            setSortAnchorEl(null);
          }}
        >
          <Typography>Oldest</Typography>
        </MenuItem>
      </Menu>
      <Menu
        sx={{ m: 0.5 }}
        open={showOpen}
        anchorEl={showAnchorEl}
        onClose={() => setshowAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setRowsPerPage(10);
            setshowAnchorEl(null);
          }}
        >
          <Typography>10 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(20);
            setshowAnchorEl(null);
          }}
        >
          <Typography>20 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(30);
            setshowAnchorEl(null);
          }}
        >
          <Typography>30 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(40);
            setshowAnchorEl(null);
          }}
        >
          <Typography>40 rows</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRowsPerPage(50);
            setshowAnchorEl(null);
          }}
        >
          <Typography>50 rows</Typography>
        </MenuItem>
      </Menu>

      <Menu
        sx={{
          m: 0.5,
          "& .MuiPaper-root.MuiPopover-paper.MuiMenu-paper": {
            marginTop: "-30px !important",
          },
        }}
        open={MoreOpen}
        anchorEl={moreAnchorEl}
        onClose={() => setMoreAnchorEl(null)}
      >
        <MenuItem onClick={() => navigate("edit-item", { state: item })}>
          <Typography>Edit</Typography>
        </MenuItem>
        <MenuItem>
          <Typography onClick={() => setshowDeleteModal(true)}>
            Delete
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ServiceTable;
